/**
 * State
 */
const state = {
  loading: false,
  loaded: false,
  counter: 0
};

/**
 * Getters
 */
const getters = {
  isLoading: state => state.loading,
  isLoaded: state => state.loaded
};

/**
 * Actions
 */
const actions = {
  setLoading({ commit, state }, status) {
    if (status === true) {
      commit('setCounter', state.counter + 1);
      if (state.counter > 0) {
        commit('setLoading', status);
      }
    } else {
      if (state.counter > 0) {
        commit('setCounter', state.counter - 1);
      }
      if (state.counter === 0) {
        setTimeout(() => {
          commit('setLoading', status);
        }, 600);
      }
    }
  }
};

/**
 * Mutations
 */
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },

  setLoaded(state, status) {
    state.loaded = status;
  },

  setCounter(state, counter) {
    state.counter = counter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
